import { useState, useEffect } from 'react'

/**
 * Hook para detectar se o dispositivo é móvel
 * Considera móvel quando a largura da tela é menor que 768px
 */
export const useIsMobile = (breakpoint: number = 768) => {
  // Initialize with current window size if available (SSR safe)
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < breakpoint
    }
    return false
  })
  const [screenWidth, setScreenWidth] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth
    }
    return 0
  })

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth
      setScreenWidth(width)
      setIsMobile(width < breakpoint)
    }

    // Verificação inicial (in case window wasn't available during useState)
    checkDevice()

    // Listener para mudanças de tamanho
    window.addEventListener('resize', checkDevice)

    // Cleanup
    return () => window.removeEventListener('resize', checkDevice)
  }, [breakpoint])

  return {
    isMobile,
    screenWidth,
    isTablet: screenWidth >= 768 && screenWidth < 1024,
    isDesktop: screenWidth >= 1024
  }
} 